@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.passengerwallet
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.core.DateTimeDto

data class PassengerWalletDto(
    val id: KmmLong?,
    val passengerId: KmmLong,
    val currencyId: Int,
    val balance: Double,
    val lastUpdated: DateTimeDto,
)
